import React, { useContext } from 'react';
import { X } from 'lucide-react';
import AppContext from '../../../../../context/AppContext';

const Lightbox = ({ item, onClose }) => {
  const { baseUrlForFile } = useContext(AppContext);
  if (!item) return null;
  return (
    <div className="aj-lb" onClick={onClose}>
      <button className="aj-lb__close" onClick={onClose}><X size={20} /></button>
      <div className="aj-lb__content" onClick={e => e.stopPropagation()}>
        {item.type === 'video'
          ? <video
              src={`${baseUrlForFile}${item.file}`}
              controls
              autoPlay
              className="aj-lb__media"
            />
          : <img
              src={`${baseUrlForFile}${item.file}`}
              alt=""
              className="aj-lb__media"
            />}
      </div>
    </div>
  );
};

export default Lightbox;